var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.backendErrors.length)?_c('div',{staticClass:"c-backend-errors"},_vm._l((_vm.backendErrors),function(code){return _c('BCXMarkdown',{key:code,staticClass:"bcx-error-text",attrs:{"tag":"p","text":_vm.markdownErrorText(code)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }